export default "__VITE_ASSET__fd6132c7__"